export default "__VITE_ASSET__RbARViXB__"